import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack';
import 'rc-tree/assets/index.css';
import { isMobile } from 'react-device-detect';
import Tree, { TreeNode } from 'rc-tree';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkPermission, checkApiStatus, getFileIcon } from '../../../utils';
import { ReportsTab } from '../components';
import { ExportManu, PageLoader, EmptyCollection } from '../../../shared_elements';
import { assetTypeValues } from '../../../constants';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, Grid, Paper } from '@material-ui/core';
import folderIcon from '../../../assets/images/folder_icon.svg';
import openFolderIcon from '../../../assets/images/open_folder.svg';
import { getAllAssetListAc } from '../../../shared_elements/actionCreators';
import DeploymentMessage from '../../../shared_elements/components/DeploymentMessage';
const InventoryTree = ({treeList, onSelect, fileIcons=[]}) => {
    const loop = (data) => {
        return data.map((item) => {
            if (item.children) {
                return <TreeNode icon={(props) => props.expanded ? <img width="14" src={openFolderIcon} alt="" /> : <img width="14" src={folderIcon} alt="" />} title={item.name} type={item.type} uuid={item.uuid} fileItem={item} key={item.uuid}>{loop(item.children)}</TreeNode>;
            }
            return (
                <TreeNode icon={item.type == "file" ? <img src={getFileIcon(fileIcons, 'pdf')} width="14" /> : <img src={folderIcon} alt="" />} title={item.name} fileItem={item} type={item.type} uuid={item.uuid} key={item.uuid} isLeaf={item.type == "folder" ? false : true} disabled={item.leaf && item.type != 'folder' ? 'disabled' : ''}/>
            );
        });
    };
    let treeNodes = loop(treeList.children);
    return(
        <Tree
            onSelect={onSelect}
            showLine={true}
            multiple={true}
            autoExpandParent={true}
            defaultExpandAll={true}
            defaultExpandParent={true}
            >
            {treeNodes}
        </Tree>
    )
}
const InventoryBigTree = ({treeList, onSelect, fileIcons=[]}) => {
    const loop = (data, depth = 1) => {
        return data.map((item) => {
          const indentation = Array(depth).fill('\u00A0\u00A0\u00A0\u00A0');
          if (item.children && item.children.length > 0) {
            return (
              <div key={item.uuid} >
                <div style={{marginTop:'3px'}}>{indentation}<img height='13px' src={openFolderIcon}/> {item.name}</div>
                {loop(item.children, depth + 1)}
              </div>
            );
          }
      
          return (
            <div>
            <span key={item.uuid} onClick={(e)=>item.type == "file"?onSelect('fileData',item.uuid):e.preventDefault()} style={{cursor:item.type == "file"?'pointer':'default', marginTop:'3px'}}>
              {indentation}<img height='16px' style={{marginRight:"3px"}} src={item.type == "file" ? getFileIcon(fileIcons, 'pdf'):folderIcon} width="14" />  {item.name}
            </span>
            </div>
          );
        });
      };
    let treeNodes = loop(treeList.children);
    return(
            <div>{treeNodes}</div>
    )
}
const Inventories = ({}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [inventoriesInfo, setInventoriesInfo] = useState({name:'', children:[]});
    const [selectAsset, setSelectAsset] = useState(null)
    const [lageDataMode, setLageDataMode] = useState(false)
    const allAssets = useSelector(state => state?.shareReducer?.allAssets||[])
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getAllAssetListAc())
    },[]);
    const onSelect = (info, node) => {
        if(info == 'fileData'){
            window.open(`/records/preview/${node}`, '_blank')
        }
        else if(node.node.props.type == 'file'){
                window.open(`/records/preview/${node.node.props.fileItem.uuid}`, '_blank')
        }
    }
    const getInventoriesInfo = (asset) => {
        setInventoriesInfo({name:'', children:[]});
        if(asset){
            setLoading(true);
            globalGetService(`records/v2/${assetTypeValues[asset.asset_type].urlType}/${asset.slug}/report/inventory/`)
            .then(response => {
                if(checkApiStatus(response)){
                    setTimeout(()=>{
                        setInventoriesInfo(response.data.data)
                    },100)
                    if(response.data?.large_data==true){
                        setLageDataMode(true)
                    }
                }
                setLoading(false);
            })
        }
    }
    const exportAssetInventory = (asset) => {
        setLoading(true)
        globalGetService(`records/v2/${assetTypeValues[asset.asset_type].urlType}/${asset.slug}/report/inventory/`,{download:true})
        .then(response => {
            if(checkApiStatus(response)){
                enqueueSnackbar(response.data.message,{variant:'success',anchorOrigin:{vertical: 'top',horizontal: 'right'}})
            }else{
                enqueueSnackbar(response.data.message,{variant:'error',anchorOrigin:{vertical: 'top',horizontal: 'right'}})
            }
            setLoading(false)
        });
    }
    return(
        <section className='fleets-management inventory'>
            <DeploymentMessage />
            <ReportsTab tabIndex="inventory" />
            <Paper sqaure style={{padding:'5px 10px'}}>
                <Grid container spacing={1} alignItems='center'>
                    <Grid item md={4} xs={inventoriesInfo?.children?.length > 0 ? 8 : 12}>
                        <div className='records-dataroom-modal'>
                            <Autocomplete
                                options = {allAssets.sort((a, b) => a.unique_name !== b.unique_name ? a.unique_name < b.unique_name ? -1 : 1 : 0)}
                                clearOnBlur={false}
                                getOptionLabel={option => option.unique_name}
                                filterSelectedOptions={true}
                                value={selectAsset}
                                onChange={(e, value) => {setSelectAsset(value);getInventoriesInfo(value)}}
                                renderInput={params => <TextField {...params} label="Select Asset" margin="normal" fullWidth InputLabelProps={{shrink: true}} variant='outlined' />}
                            />
                        </div>
                        
                    </Grid>
                    { inventoriesInfo?.children?.length > 0 && checkPermission('reports','inventory','EXP') ?
                        <Grid item md={8} xs={4}>
                            <ul className='list-inline' style={{float:'right'}}>
                                <li className='list-inline-item'>
                                    <ExportManu
                                        title="Export"
                                        files={[{title:'Excel', extension: 'xlsx', key:''}]}
                                        exportReportFn={(file) => exportAssetInventory(selectAsset)}
                                    />
                                </li>
                            </ul>
                        </Grid>:null
                    }
                </Grid>
            </Paper>
            <Paper className='mobile-rc-tree-paper' style={{minHeight:'380px', marginTop:'15px'}}>
                { !selectAsset?.slug ? <h5 style={{textAlign:'center', padding:'60px 0'}}>Select an asset to get Inventory Report</h5>:null}
                { inventoriesInfo?.children?.length ?
                    <div style={{overflow:'auto'}}>
                        {lageDataMode ?
                        <InventoryBigTree 
                            treeList={inventoriesInfo}
                            onSelect={onSelect}
                            fileIcons={[]}
                        />:
                         <InventoryTree 
                            treeList={inventoriesInfo}
                            onSelect={onSelect}
                            fileIcons={[]}
                        />}
                    </div>:
                    selectAsset?.slug ?
                    <EmptyCollection
                        title="No Records Found"
                    /> : null
                }
            </Paper>
            { isLoading ? <PageLoader/>:null }
        </section>
    )
}
export default Inventories;